import React, { useState } from "react";
import { trackManual } from "../api";
import ExitTimePicker from "./ExitTimePicker";

export default function ManualTrackPanel({ positions, selected, onTracked }) {
  const [name, setName] = useState("");
  const [target, setTarget] = useState("");
  const [stoploss, setStoploss] = useState("");
  const [exitTime, setExitTime] = useState("");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState(null);

  const selectedPositions = positions.filter((p) => selected.includes(p.tradingsymbol));
  const combinedPnl = selectedPositions.reduce((sum, p) => sum + (p.pnl ?? 0), 0);

  const handleTrack = async () => {
    if (selected.length === 0) {
      setMessage("Tick at least one leg in the table above first.");
      return;
    }
    if (!name.trim()) {
      setMessage("Give this group a name.");
      return;
    }
    setBusy(true);
    setMessage(null);
    try {
      await trackManual({
        name: name.trim(),
        symbols: selected,
        target: Number(target) || 0,
        stoploss: Number(stoploss) || 0,
        square_off_time: exitTime || null,
      });
      setMessage("Tracking started — see it under the Strategies tab.");
      setName("");
      setTarget("");
      setStoploss("");
      setExitTime("");
      if (onTracked) onTracked();
    } catch (err) {
      setMessage(err.response?.data?.detail || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="strategy-panel">
      <div className="field-group">
        <label>Selected legs ({selected.length})</label>
        {selected.length === 0 ? (
          <p className="muted">Tick legs in the positions table to form a group.</p>
        ) : (
          <>
            <ul className="symbol-list">
              {selected.map((s) => <li key={s}>{s}</li>)}
            </ul>
            <div className={`combined-pnl ${combinedPnl >= 0 ? "pnl-positive" : "pnl-negative"}`}>
              {combinedPnl.toLocaleString("en-IN", { maximumFractionDigits: 2 })}
            </div>
          </>
        )}
      </div>

      <div className="field-group">
        <label>Group name</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Today's IC" />
      </div>

      <div className="field-group inline">
        <div>
          <label>Target P&amp;L (₹)</label>
          <input type="number" value={target} onChange={(e) => setTarget(e.target.value)} placeholder="e.g. 3000" />
        </div>
        <div>
          <label>Stop-loss P&amp;L (₹)</label>
          <input type="number" value={stoploss} onChange={(e) => setStoploss(e.target.value)} placeholder="e.g. -2000" />
        </div>
      </div>

      <div className="field-group">
        <label>Exit time (optional)</label>
        <ExitTimePicker value={exitTime} onChange={setExitTime} />
        <p className="hint">Square off this group at this time if target/stoploss haven't fired.</p>
      </div>

      <button onClick={handleTrack} disabled={busy || selected.length === 0}>
        {busy ? "Starting..." : "Track & Auto-Exit This Group"}
      </button>

      {message && <div className="banner info">{message}</div>}
    </div>
  );
}
